import React from 'react';
import Select from 'react-select';

// Configurador de premios de una liga.
//
// Un premio es o una recompensa del catalogo de la web, o una cantidad de overbox o de birux.
// Se usa igual para las posiciones (Top 1, Top 2...) y para el premio por defecto, que es el
// que cobra todo el que participa y no entra en ninguna posicion premiada.

export const PRIZE_TYPES = [
    { value: 'reward', label: 'Recompensa de la web' },
    { value: 'overbox', label: 'Overbox' },
    { value: 'birux', label: 'Birux Bronce' },
    { value: 'biruxComodin', label: 'Birux Comodin' },
    { value: 'biruxPlata', label: 'Birux Plata' },
    { value: 'biruxOro', label: 'Birux Oro' },
];

export const emptyPrize = () => ({ kind: 'overbox', rewardId: '', amount: 1 });

const selectStyles = {
    control: (provided) => ({ ...provided, backgroundColor: 'rgb(81, 84, 82)', borderColor: '#444', color: '#fff', minWidth: 190 }),
    menu: (provided) => ({ ...provided, backgroundColor: 'rgb(81, 84, 82)', zIndex: 30 }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused ? 'rgba(255, 255, 255, 0.1)' : 'rgb(81, 84, 82)',
        color: '#fff',
        cursor: 'pointer',
    }),
    singleValue: (provided) => ({ ...provided, color: '#fff' }),
    input: (provided) => ({ ...provided, color: '#fff' }),
    placeholder: (provided) => ({ ...provided, color: '#ccc' }),
};

// Una fila: tipo + (recompensa | cantidad). El selector de recompensa solo aparece si hace falta.
const PrizeRow = ({ prize, rewardOptions, onChange }) => {
    const isReward = prize.kind === 'reward';
    const selectedReward = rewardOptions.find(o => o.value === String(prize.rewardId)) || null;

    return (
        <>
            <Select
                className='heroes selectForm'
                options={PRIZE_TYPES}
                styles={selectStyles}
                value={PRIZE_TYPES.find(t => t.value === prize.kind) || null}
                onChange={(opt) => onChange({ ...prize, kind: opt.value, rewardId: opt.value === 'reward' ? prize.rewardId : '' })}
            />
            {isReward ? (
                <Select
                    className='heroes selectForm'
                    options={rewardOptions}
                    isSearchable
                    styles={selectStyles}
                    placeholder='Elige la recompensa'
                    value={selectedReward}
                    onChange={(opt) => onChange({ ...prize, rewardId: opt ? opt.value : '' })}
                />
            ) : null}
            <input
                className='userSearch'
                type='number'
                min='1'
                style={{ width: 90, flex: 'none' }}
                value={prize.amount}
                onChange={(e) => onChange({ ...prize, amount: e.target.value })}
                onWheel={(e) => e.currentTarget.blur()}
            />
            {isReward && selectedReward && selectedReward.image ? (
                <img className='prizePreview' src={selectedReward.image} alt='' />
            ) : null}
        </>
    );
};

const PrizeEditor = ({ prizes, defaultPrize, rewardOptions, onChangePrizes, onChangeDefault }) => {
    const setPrize = (index, next) => {
        const copy = prizes.slice();
        copy[index] = next;
        onChangePrizes(copy);
    };

    return (
        <>
            <h3>Premios por puesto</h3>
            <p style={{ fontSize: 13, color: '#ccc' }}>
                El puesto lo da la clasificacion de la temporada. Los <strong>empatados a victorias
                comparten puesto</strong> y cobran los dos el mismo premio, asi que dos primeros
                empatados son los dos Top 1 y el siguiente pasa a ser Top 3.
            </p>

            {prizes.length === 0 ? <p>Sin premios por puesto.</p> : null}

            {prizes.map((prize, index) => (
                <div key={index} className='formFieldRow prizeRow'>
                    <label className='formFieldLabel heroes' style={{ minWidth: 70 }}>Top {index + 1}</label>
                    <PrizeRow
                        prize={prize}
                        rewardOptions={rewardOptions}
                        onChange={(next) => setPrize(index, next)}
                    />
                    <div
                        className='miniBtn heroes unselectable'
                        onClick={() => onChangePrizes(prizes.filter((_, i) => i !== index))}
                    >
                        Quitar
                    </div>
                </div>
            ))}

            <div className='navTops heroes unselectable'>
                <div onClick={() => onChangePrizes(prizes.concat([emptyPrize()]))}>Añadir puesto</div>
            </div>

            <h3>Premio por defecto</h3>
            <p style={{ fontSize: 13, color: '#ccc' }}>
                Lo cobra todo el que tenga al menos una victoria en la temporada y no haya entrado
                en ninguno de los puestos premiados de arriba. Si tu puesto ya tiene premio, te
                llevas el del puesto, no este.
            </p>

            {defaultPrize ? (
                <div className='formFieldRow prizeRow'>
                    <label className='formFieldLabel heroes' style={{ minWidth: 70 }}>Todos</label>
                    <PrizeRow
                        prize={defaultPrize}
                        rewardOptions={rewardOptions}
                        onChange={onChangeDefault}
                    />
                    <div className='miniBtn heroes unselectable' onClick={() => onChangeDefault(null)}>Quitar</div>
                </div>
            ) : (
                <div className='navTops heroes unselectable'>
                    <div onClick={() => onChangeDefault(emptyPrize())}>Añadir premio por defecto</div>
                </div>
            )}
        </>
    );
};

export default PrizeEditor;
